namespace GeniuzPOS.AdvPromo {
    export interface PsPromoAvDaysForm {
        PmGroupId: Serenity.StringEditor;
        PromoDay: Serenity.IntegerEditor;
    }

    export class PsPromoAvDaysForm extends Serenity.PrefixedContext {
        static formKey = 'AdvPromo.PsPromoAvDays';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsPromoAvDaysForm.init)  {
                PsPromoAvDaysForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;

                Q.initFormType(PsPromoAvDaysForm, [
                    'PmGroupId', w0,
                    'PromoDay', w1
                ]);
            }
        }
    }
}
